






import {
  Vue,
  Component,
  Prop,
  Watch
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { ImpersonationError } from "@/employee/route-names";
import * as datadog from "@/shared/datadog";
import { AuthType } from "@/shared/types";
import { useUserStore } from "@/shared/store/user";
import { useImpersonatorStore } from "@/shared/store/impersonator";

@Component({
  components: {
    GenericLoadingSpinner
  }
})

export default class InitiateImpersonation extends Vue {
  userStore = useUserStore();
  impersonatorStore = useImpersonatorStore();

  @Prop()
  token: string;

  mounted () {
    if (!this.token) {
      this.redirectToImpersonationError();
    }

    this.impersonatorStore.retrieveInitiateResponse(this.token)
    .catch(_ => {
      this.redirectToImpersonationError();
    });
  }

  redirectToImpersonationError () {
    datadog.log("Error in impersonation initiation", { fullPath: this.$route.fullPath }, "error");
    this.$router.push({ name: ImpersonationError });
  }

  @Watch("impersonatorStore.initiateResponseLoaded")
  watchInitiateResponseLoaded () {
    if (!this.impersonatorStore.initiateResponseLoaded) {
      return;
    }

    this.userStore.setAuthType(this.impersonatorStore.impersonationAuthType);

    try {
      this.impersonatorStore.startPartnerImpersonation({
        impersonationInfo: this.impersonatorStore.impersonationInitiateData.impersonationInfo,
        isEmployeePortal: true,
        router: this.$router,
        forcePageReload: false
      } as any);
    }
    catch {
      this.$router.push({ name: ImpersonationError });
    }
  }
}
